import React, { useState } from "react";
import { Container, Spinner } from "react-bootstrap";
import TextField from "@mui/material/TextField";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { useEffect } from "react";
import notify from "../../../Notifcation";
import { useDispatch, useSelector } from "react-redux";
import {
  GetQouteSideAction,
  InsertusersubdashAction,
  UpdateUserdashAction,
} from "../../../../redux/actions/UserSubscriptionAction";
import {
  getUserAndSubuserAction,
  getUserSubscriptionAction,
} from "../../../../redux/actions/ManageAdminAction";
const filter = createFilterOptions();
const Enter = ({
  File,
  setFile,
  Base64,
  setBase64,
  Datee1,
  Datee2,
  setDate2,
  setDate1,
  QuoteId,
  setUserid,
  Userid,
  Feedback,
  setFeedback,
  Free,
  setFree,
  Paid,
  setPaid,
  Username,
  Active,
  setActive,
  val,
  setVal,
  Archivemega,
  setArchivemega,
  moye,
  setmoye,
  duration,
  setDuration,
  monthCount,
  yearCount,
  foc,
  setfoc,
  setLoading,
  setIsPress,
  loading,
  isPress,
  isEdit,
  RowId,
  DateTwo,
  setisEdit,
  setisValue,
  isValue,
}) => {
  const dispatch = useDispatch();
  const AllQo = useSelector((state) => state.UserSubscriptionR.GetQoutside);
  const [PriceOneGiga, setPriceOneGiga] = useState("");
  const [Pricetotal, setPricetotal] = useState(0);
  const [Year, setYear] = useState("");
  const [Month, setMonth] = useState("");
  const [Userss, setUserss] = useState("");
  const { Createusersubdash, UpdateSubDashboard } = useSelector(
    (state) => state.UserSubscriptionR
  );
  useEffect(() => {
    const getAll = async () => {
      await dispatch(GetQouteSideAction());
      setMonth(AllQo.pricePerMonth);
      setYear(AllQo.pricePerYear);
      setPriceOneGiga(AllQo.pricePerGB);
    };
    getAll();
  }, []);
  const userAndsubuser = useSelector(
    (state) => state.ManageAdminR.UserAndSubuser
  );
  const handleGiga = (e) => {
    setArchivemega(e.target.value);
    setisValue(false);
  };
  useEffect(() => {
    if (Archivemega === 200) {
      setPricetotal(0 * PriceOneGiga);
    }
    if (Archivemega === 1024) {
      setPricetotal(1 * PriceOneGiga);
    }
    if (Archivemega === 2048) {
      setPricetotal(2 * PriceOneGiga);
    }
    if (Archivemega === 3072) {
      setPricetotal(3 * PriceOneGiga);
    }
  }, [Archivemega, isValue]);
  useEffect(() => {
    dispatch(getUserAndSubuserAction());
  }, []);
  useEffect(() => {
    if (Paid) {
      setFree(false);
    }
  }, [Paid]);
  useEffect(() => {
    if (Free) {
      setPaid(false);
    }
  }, [Free]);
  useEffect(() => {
    if (AllQo && AllQo.pricePerMonth) {
      setMonth(AllQo.pricePerMonth);
      setYear(AllQo.pricePerYear);
      setPriceOneGiga(AllQo.pricePerGB);
    }
  }, [moye]);
  useEffect(() => {
    if (moye === 1) {
      // if (duration === 3) {
      //   const today = new Date();
      //   if (Paid || Free) {
      //     const lastdur = new Date(DateTwo.split("/").reverse().join("/"));
      //     const date1 = lastdur.toLocaleDateString("en-GB");
      //     const date2 = lastdur;
      //     date2.setMonth(date2.getMonth() + 3);
      //     const last = date2.toLocaleDateString("en-GB");
      //     setDate1(date1);
      //     setDate2(last);
      //     // setVal(3 * Month + Pricetotal * 3);
      //     setfoc(true);
      //   } else {
      //     const date1 = today.toLocaleDateString("en-GB");
      //     const date2 = today;
      //     date2.setMonth(date2.getMonth() + 3);
      //     const last = date2.toLocaleDateString("en-GB");
      //     setDate1(date1);
      //     setDate2(last);
      //     // setVal(3 * Month + 3 * Pricetotal);
      //     setfoc(true);
      //   }
      // }
      if (duration === 6) {
        const today = new Date();
        if (Paid || Free) {
          const lastdur = new Date(DateTwo.split("/").reverse().join("/"));
          const date1 = lastdur.toLocaleDateString("en-GB");
          const date2 = lastdur;
          date2.setMonth(date2.getMonth() + 6);
          date2.toLocaleDateString("en-GB");
          const last = date2.toLocaleDateString("en-GB");
          setDate1(date1);
          setDate2(last);
          // setVal(6 * Month + Pricetotal * 6);
          setfoc(true);
        } else {
          const date1 = today.toLocaleDateString("en-GB");
          const date2 = today;
          date2.setMonth(date2.getMonth() + 6);
          date2.toLocaleDateString("en-GB");
          const last = date2.toLocaleDateString("en-GB");
          setDate1(date1);
          setDate2(last);
          // setVal(6 * Month + 6 * Pricetotal);
          setfoc(true);
        }
      }
    } else if (moye === 2) {
      if (duration === 1) {
        const today = new Date();
        if (Paid || Free) {
          const lastdur = new Date(DateTwo.split("/").reverse().join("/"));
          const date1 = lastdur.toLocaleDateString("en-GB");
          const date2 = lastdur;
          date2.setFullYear(date2.getFullYear() + 1);
          const last = date2.toLocaleDateString("en-GB");
          setDate1(date1);
          setDate2(last);
          // setVal(Year + Pricetotal * 12);
          setfoc(true);
        } else {
          const date1 = today.toLocaleDateString("en-GB");
          const date2 = today;
          date2.setFullYear(date2.getFullYear() + 1);
          const last = date2.toLocaleDateString("en-GB");
          setDate1(date1);
          setDate2(last);
          // setVal(Year + Pricetotal * 12);
          setfoc(true);
        }
      }
      if (duration === 2) {
        const today = new Date();
        if (Paid || Free) {
          const lastdur = new Date(DateTwo.split("/").reverse().join("/"));
          const date1 = lastdur.toLocaleDateString("en-GB");
          const date2 = lastdur;
          date2.setFullYear(date2.getFullYear() + 2);
          date2.toLocaleDateString("en-GB");
          const last = date2.toLocaleDateString("en-GB");
          setDate1(date1);
          setDate2(last);
          // setVal(2 * Year + Pricetotal * 24);
          setfoc(true);
        } else {
          const date1 = today.toLocaleDateString("en-GB");
          const date2 = today;
          date2.setFullYear(date2.getFullYear() + 2);
          date2.toLocaleDateString("en-GB");
          const last = date2.toLocaleDateString("en-GB");
          setDate1(date1);
          setDate2(last);
          // setVal(2 * Year + 24 * Pricetotal);
          setfoc(true);
        }
      }
      if (duration === 3) {
        const today = new Date();
        if (Paid || Free) {
          const lastdur = new Date(DateTwo.split("/").reverse().join("/"));
          const date1 = lastdur.toLocaleDateString("en-GB");
          const date2 = lastdur;
          date2.setFullYear(date2.getFullYear() + 3);
          date2.toLocaleDateString("en-GB");
          const last = date2.toLocaleDateString("en-GB");
          setDate1(date1);
          setDate2(last);
          // setVal(3 * Year + Pricetotal * 36);
          setfoc(true);
        } else {
          const date1 = today.toLocaleDateString("en-GB");
          const date2 = today;
          date2.setFullYear(date2.getFullYear() + 3);
          date2.toLocaleDateString("en-GB");
          const last = date2.toLocaleDateString("en-GB");
          setDate1(date1);
          setDate2(last);
          // setVal(3 * Year + 36 * Pricetotal);
          setfoc(true);
        }
      }
    }
  }, [duration, moye]);
  useEffect(() => {
    if (isValue) return;
    if (moye === 1) {
      // if (duration === 3) {
      //   setVal(3 * Month + Pricetotal * 3);
      //   setfoc(true);
      // }
      if (duration === 6) {
        setVal(6 * Month + Pricetotal * 6);
        setfoc(true);
      }
    } else if (moye === 2) {
      if (duration === 1) {
        setVal(Year + Pricetotal * 12);
        setfoc(true);
      }

      if (duration === 2) {
        setVal(2 * Year + Pricetotal * 24);
        setfoc(true);
      }

      if (duration === 3) {
        setVal(3 * Year + Pricetotal * 36);
        setfoc(true);
      }
    }
  }, [duration, moye, Pricetotal, isValue]);
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (
      Userss === null ||
      QuoteId === null ||
      val === null ||
      Datee1 === null ||
      Datee2 === null ||
      Archivemega === null ||
      moye === null ||
      duration === null
    ) {
      notify("من فضلك اكمل البيانات المطلوبة", "warn");
      return;
    }
    if (File && File.size > 5000000) {
      notify("من فضلك يجب ان يكون حجم الملف 5 ميجا او اقل  ", "error");
      return;
    }
    const formData = new FormData();
    formData.append("UserId", Userss ? Userss.id : null);
    formData.append("QuoteName", "أعمال الموارد البشرية");
    formData.append("QuoteId", 3);
    formData.append("From", Datee1.split("/").reverse().join("/"));
    formData.append("To", Datee2.split("/").reverse().join("/"));
    formData.append("Value", val);
    formData.append("SubscriptionSizeOnS3", Archivemega);
    formData.append("Note", Feedback);
    formData.append("IsFree", Free);
    formData.append("IsPaid", Paid);
    // formData.append("active", Active);
    formData.append("File", File);

    setLoading(true);
    setIsPress(true);
    await dispatch(InsertusersubdashAction(formData));
    await dispatch(getUserSubscriptionAction());
    setLoading(false);
    setIsPress(false);
    setVal(0);
    setUserid("");
    setDate1("");
    setDate2("");
    setArchivemega(200);
    setBase64("");
    setFile("");
    setActive(false);
    setPaid(false);
    setFeedback("");
    setFree(false);
    setDuration("");
    setmoye(0);
  };
  const handleUpdate = async (e) => {
    e.preventDefault();
    if (
      QuoteId === null ||
      val === null ||
      Datee1 === null ||
      Datee2 === null ||
      Archivemega === null
      // ||
      // moye === null ||
      // duration === null
    ) {
      notify("من فضلك اكمل البيانات المطلوبة", "warn");
      return;
    }
    if (File && File.size > 5000000) {
      notify("من فضلك يجب ان يكون حجم الملف 5 ميجا او اقل  ", "error");
      return;
    }
    const formData = new FormData();
    formData.append("Id", RowId);
    formData.append("QuoteName", "أعمال الموارد البشرية");

    formData.append("ApplicationUserId", Userid);
    formData.append("From", Datee1.split("/").reverse().join("/"));
    formData.append("To", Datee2.split("/").reverse().join("/"));
    formData.append("Value", val);
    formData.append("Note", Feedback);
    formData.append("SubscriptionSizeOnS3", Archivemega);
    formData.append("IsFree", Free);
    formData.append("IsPaid", Paid);
    formData.append("IsActive", Active);
    formData.append("Image", File);
    setLoading(true);
    setIsPress(true);
    await dispatch(UpdateUserdashAction(formData));
    await dispatch(getUserSubscriptionAction());
    setLoading(false);
    setIsPress(false);
    setisEdit(false);

    setUserid("");
    setDate1("");
    setDate2("");
    setVal(0);
    setArchivemega(200);
    setBase64("");
    setFile("");
    setActive(false);
    setPaid(false);
    setFeedback("");
    setFree(false);
    setDuration("");
    setmoye(0);
  };
  function formatFileSize(bytes) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
  }
  function importData() {
    let input = document.createElement("input");
    input.type = "file";
    input.multiple = "false";
    input.onchange = (e) => {
      setFile(e.target.files[0]);
      const reader = new FileReader();
      reader.onload = () => {
        const base64 = reader.result;
        setBase64(base64);
      };

      reader.readAsDataURL(e.target.files[0]);
    };

    input.click();
  }

  const deleteFile = () => {
    setFile("");
    setBase64("");
  };
  useEffect(() => {
    if (loading === false) {
      if (Createusersubdash) {
        if (
          Createusersubdash.status === 200 ||
          Createusersubdash.status === 201
        ) {
          if (Createusersubdash.data) {
            if (
              Createusersubdash.data.responseMessage ===
              "User subscription added successfuly"
            ) {
              notify("تم الاشتراك بنجاح", "success");
            }
          }
        } else if (
          Createusersubdash.status !== 200 ||
          Createusersubdash.status !== 201
        ) {
          // if (res.data && res.data.responseMessage==="phoneNumber or Password is incorrect!") {
          //   notify("خطأ في كلمة السر او رقم الهاتف", "error");
          // }
          // else
          notify("حدث خطأ حاول مرة اخرى", "error");
        }
      }

      if (UpdateSubDashboard) {
        if (
          UpdateSubDashboard.status === 200 ||
          UpdateSubDashboard.status === 201
        ) {
          if (UpdateSubDashboard.data) {
            if (
              UpdateSubDashboard.data.responseMessage ===
              "User subscription updated successfully"
            ) {
              notify("تم تعديل الأشتراك بنجاح", "success");
            } else if (
              UpdateSubDashboard.data.responseMessage ===
              "You have to choose if it is free or paid subscription"
            ) {
              notify("يجب اختيار مدفوع او مجاني", "warn");
            }
          }
        } else if (
          UpdateSubDashboard.status !== 200 ||
          UpdateSubDashboard.status !== 201
        ) {
          // if (res.data && res.data.responseMessage==="phoneNumber or Password is incorrect!") {
          //   notify("خطأ في كلمة السر او رقم الهاتف", "error");
          // }
          // else
          notify("حدث خطأ حاول مرة اخرى", "error");
        }
      }
    }
  }, [loading]);
  return (
    <>
      <div className="enterr">
        <Container>
          <div className="inputs-container">
            {isEdit ? (
              <div className="inp-container ">
                {" "}
                <TextField
                  focused={foc}
                  value={Username}
                  label={
                    <Typography
                      sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                      اسم المستخدم
                      <span style={{ color: "red", fontSize: "19px" }}>*</span>
                    </Typography>
                  }
                  variant="outlined"
                  className="ww"
                  inputProps={{ maxLength: 120 }}
                  type="text"
                  // value={5}
                />
              </div>
            ) : (
              <div className="inp-container ">
                <Autocomplete
                  value={Userss}
                  onChange={(event, newValue) => {
                    if (typeof newValue === "string") {
                      setUserss({
                        title: newValue,
                      });
                    } else if (newValue && newValue.inputValue) {
                      // Create a new value from the user input
                      setUserss({
                        title: newValue.inputValue,
                      });
                    } else {
                      setUserss(newValue);
                    }
                  }}
                  filterOptions={(options, params) => {
                    const filtered = filter(options, params);

                    const { inputValue } = params;
                    // Suggest the creation of a new value
                    const isExisting = options.some(
                      (option) => inputValue === option.title
                    );
                    if (inputValue !== "" && !isExisting) {
                      filtered.push({
                        inputValue,
                        // title: `لا توجد حسابات بهذا الاسم"${inputValue}"`,
                      });
                    }

                    return filtered;
                  }}
                  selectOnFocus
                  clearOnBlur
                  handleHomeEndKeys
                  options={
                    userAndsubuser &&
                    userAndsubuser.data &&
                    userAndsubuser.data.data.length >= 0
                      ? userAndsubuser.data.data
                      : []
                  }
                  getOptionLabel={(option) => {
                    // Value selected with enter, right from the input
                    if (typeof option === "string") {
                      return option;
                    }
                    // Add "xxx" option created dynamically
                    if (option.inputValue) {
                      return option.inputValue;
                    }
                    // Regular option
                    return option.phoneNumber;
                  }}
                  renderOption={(props, option) => (
                    <li {...props} key={option.id}>
                      {option.phoneNumber}
                    </li>
                  )}
                  sx={{ width: 300 }}
                  freeSolo
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <Typography
                          sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                          رقم الهاتف
                          <span style={{ color: "red", fontSize: "19px" }}>
                            *
                          </span>
                        </Typography>
                      }
                    />
                  )}
                />
              </div>
            )}
            <div className="inp-container ">
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  <Typography sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                    اسم البرنامج
                    <span style={{ color: "red", fontSize: "19px" }}>*</span>
                  </Typography>
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  value={QuoteId}
                  label={
                    <Typography
                      sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                      اسم البرنامج
                      <span style={{ color: "red", fontSize: "19px" }}>*</span>
                    </Typography>
                  }>
                  <MenuItem value={1}>أعمال الموارد البشرية</MenuItem>
                </Select>
              </FormControl>
            </div>
            <div className="inp-container daa">
              {" "}
              <div>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    {
                      <Typography
                        sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                        الاشتراك
                        <span style={{ color: "red", fontSize: "19px" }}>
                          *
                        </span>
                      </Typography>
                    }
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    value={moye}
                    focused={foc}
                    onChange={(e) => setmoye(e.target.value)}
                    label={
                      <Typography
                        sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                        الاشتراك
                        <span style={{ color: "red", fontSize: "19px" }}>
                          *
                        </span>
                      </Typography>
                    }>
                    <MenuItem value={1}>شهر</MenuItem>
                    <MenuItem value={2}>سنة</MenuItem>
                  </Select>
                </FormControl>
              </div>
              <div>
                <FormControl fullWidth focused={foc}>
                  <InputLabel id="demo-simple-select-label">
                    <Typography
                      sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                      {moye === 1 ? "عدد شهر " : moye === 2 ? "عدد سنة" : "عدد"}
                      <span style={{ color: "red", fontSize: "19px" }}>*</span>
                    </Typography>
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    value={duration}
                    onChange={(e) => {
                      setDuration(e.target.value);
                      setisValue(false);
                    }}
                    label={
                      <Typography
                        sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                        {moye === 1
                          ? "عدد شهر "
                          : moye === 2
                          ? "عدد سنة"
                          : "عدد"}
                        <span style={{ color: "red", fontSize: "19px" }}>
                          *
                        </span>
                      </Typography>
                    }>
                    {moye === 1
                      ? monthCount.map((m, idx) => (
                          <MenuItem key={idx} value={m}>
                            {m}
                          </MenuItem>
                        ))
                      : moye === 2
                      ? yearCount.map((y, idx) => (
                          <MenuItem key={idx} value={y}>
                            {y}
                          </MenuItem>
                        ))
                      : null}
                  </Select>
                </FormControl>
              </div>
            </div>
            <div className="inp-container">
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  <Typography sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                    الأرشيف
                    <span style={{ color: "red", fontSize: "19px" }}>*</span>
                  </Typography>
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  value={Archivemega}
                  onChange={handleGiga}
                  label={
                    <Typography
                      sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                      الأرشيف
                      <span style={{ color: "red", fontSize: "19px" }}>*</span>
                    </Typography>
                  }>
                  <MenuItem value={200}>200MB</MenuItem>
                  <MenuItem value={1024}>1GB</MenuItem>
                  <MenuItem value={2048}>2GB</MenuItem>
                  <MenuItem value={3072}>3GB</MenuItem>
                </Select>
              </FormControl>
            </div>
            <div className="inp-container ">
              {" "}
              <TextField
                focused={foc}
                value={val}
                onChange={(e) => setVal(parseFloat(e.target.value))}
                label={
                  <Typography sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                    القيمة
                    <span style={{ color: "red", fontSize: "19px" }}>*</span>
                  </Typography>
                }
                className="ww"
                type="number"
                // value={5}
              />
            </div>
            <div className="inp-container daa">
              <div>
                <TextField
                  focused={foc}
                  label={
                    <Typography
                      sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                      التاريخ من
                      <span style={{ color: "red", fontSize: "19px" }}>*</span>
                    </Typography>
                  }
                  className="ww"
                  variant="outlined"
                  type="text"
                  value={Datee1}
                />
              </div>
              <div>
                <TextField
                  focused={foc}
                  label={
                    <Typography
                      sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                      التاريخ إلى
                      <span style={{ color: "red", fontSize: "19px" }}>*</span>
                    </Typography>
                  }
                  variant="outlined"
                  className="ww"
                  type="text"
                  value={Datee2}
                />
              </div>
            </div>
            <div className="inp-container ">
              <div className="cch">
                <div className="input-check">
                  {" "}
                  مجاني
                  <input
                    type="checkbox"
                    value={Free}
                    checked={Free ? true : false}
                    onChange={(e) => setFree(e.target.checked)}
                  />
                </div>
                <div className="input-check">
                  {" "}
                  مدفوع
                  <input
                    type="checkbox"
                    checked={Paid ? true : false}
                    value={Paid}
                    onChange={(e) => setPaid(e.target.checked)}
                  />
                </div>
                {isEdit ? (
                  <div className="input-check">
                    {" "}
                    مفعل
                    <input
                      type="checkbox"
                      value={Active}
                      checked={Active ? true : false}
                      onChange={(e) => setActive(e.target.checked)}
                    />
                  </div>
                ) : null}
              </div>
            </div>
            <div className="inp-container">
              <TextField
                label="البيان"
                focused={foc}
                variant="outlined"
                value={Feedback}
                onChange={(e) => setFeedback(e.target.value)}
              />
              <i
                onClick={importData}
                className="ty fa-solid fa-paperclip"
                style={{ color: "#1866ec" }}></i>
            </div>
            <div className="inp-container">
              {File && (
                <div className="fi">
                  <a
                    href={Base64 ? Base64 : File}
                    target="blank"
                    download={File.name}>
                    {File.name ? (
                      File.name
                    ) : (
                      <i
                        className=" fa-solid fa-paperclip"
                        style={{ color: "#1866ec" }}></i>
                    )}
                  </a>
                  <div style={{ display: "block" }}>
                    {formatFileSize(File.size)
                      ? formatFileSize(File.size)
                      : null}
                  </div>
                  <button
                    style={{ background: "transparent" }}
                    className="buttonadd">
                    <i
                      onClick={(idx) => deleteFile(idx)}
                      className="fs fa-solid fa-trash-can icon-red"
                      style={{ color: "red" }}></i>
                  </button>
                </div>
              )}
            </div>{" "}
            <div className="inp-container "></div>
          </div>
          {isEdit ? (
            isPress && loading ? (
              <button className="buttonadd">
                <Spinner animation="border" role="status"></Spinner>
              </button>
            ) : (
              <button className="buttonadd" onClick={handleUpdate}>
                تعديل
              </button>
            )
          ) : isPress && loading ? (
            <button className="buttonadd">
              <Spinner animation="border" role="status"></Spinner>
            </button>
          ) : (
            <button className="buttonadd" onClick={handleSubmit}>
              إضافة
            </button>
          )}
        </Container>
      </div>
    </>
  );
};
export default Enter;
